/**
 * Team Chat Realtime Service
 * Usa CRM Supabase (hfxydfbutbitijsakgjh) — mesmo padrão de kbRealtime.js.
 */

import { createClient } from '@supabase/supabase-js';

const CRM_SUPABASE_URL = process.env.REACT_APP_CRM_SUPABASE_URL;
const CRM_SUPABASE_KEY = process.env.REACT_APP_CRM_SUPABASE_KEY;

let supabase = null;

function getClient() {
  if (!supabase) {
    supabase = createClient(CRM_SUPABASE_URL, CRM_SUPABASE_KEY);
  }
  return supabase;
}

/**
 * Escuta novas mensagens num canal.
 * Retorna o channel Supabase para poder cancelar.
 */
export function subscribeToChannelMessages(channelId, onMessage) {
  const client = getClient();

  const channel = client
    .channel(`team-messages-${channelId}`)
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'team_messages',
        filter: `channel_id=eq.${channelId}`,
      },
      (payload) => onMessage(payload.new)
    )
    .subscribe();

  return channel;
}

/**
 * Escuta mudanças de status (open/resolved) num canal.
 */
export function subscribeToMessageStatus(channelId, onStatusChange) {
  const client = getClient();

  const channel = client
    .channel(`team-status-${channelId}`)
    .on(
      'postgres_changes',
      {
        event: 'UPDATE',
        schema: 'public',
        table: 'team_messages',
        filter: `channel_id=eq.${channelId}`,
      },
      (payload) => onStatusChange(payload.new)
    )
    .subscribe();

  return channel;
}

/**
 * Escuta novas threads numa mensagem.
 */
export function subscribeToThreads(messageId, onThread) {
  const client = getClient();

  const channel = client
    .channel(`team-threads-${messageId}`)
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'team_threads',
        filter: `message_id=eq.${messageId}`,
      },
      (payload) => onThread(payload.new)
    )
    .subscribe();

  return channel;
}

export default {
  subscribeToChannelMessages,
  subscribeToMessageStatus,
  subscribeToThreads,
};
